export class CodeComponentMarkdown {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.name = model.name;
        this.componentKey = model.componentKey;
        this.packageName = model.packageName;
        this.componentPath = model.componentPath;
        this.markdown = model.markdown;
    }
}
